/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import { DataContext } from "../../contexts/DataContext";
import moment from "moment";
import Date from "../Games/Date";
import { ScrollBar } from "../../Theme/Hyper";
import { UIContext, MODE_CONSTS } from "../../contexts/UIContext";
import { APIContext } from "../../contexts/APIContext";
import CalendarUI from "../UI/Calendar/CalendarUI";
import "../../calendar.css";
import gql from "graphql-tag";
import { useLazyQuery, useQuery } from "@apollo/client";

const GAMES_BY_DATE = gql`
  query Games($date: String) {
    gamesByDate(date: $date) {
      _id
      time
      description
      date
      stadium {
        opta_name
        name
      }
      competition {
        oval_ID
        name
        competition_type
        badge
        secondary_badge
        flag_path
        fighter_path
        fighter_full_path
        categories
      }
      lineup {
        home {
          squad {
            _id
            shirt_number
            opta_shirt_number
            position
            stats
            player {
              _id
              first_name
              last_name
              first_name_upper
              last_name_upper
              nationality {
                _id
                code
                name
              }
              image
              stories
              corner
              weight
              wins
              losses
              draws
              height
              hometown
              reach
              legreach
              style
              age
              oval_ID
            }
          }
          order
          yellow_card
          dbl_yellow_card
          red_card
        }
        away {
          squad {
            _id
            shirt_number
            opta_shirt_number
            position
            stats
            player {
              _id
              first_name
              last_name
              first_name_upper
              last_name_upper
              nationality {
                _id
                code
                name
              }
              image
              stories
              corner
              weight
              wins
              losses
              draws
              height
              hometown
              reach
              legreach
              style
              age
              oval_ID
            }
          }
          order
          yellow_card
          dbl_yellow_card
          red_card
        }
      }
      opta_lineup {
        home {
          squad {
            _id
            opta_shirt_number
            stats
            player {
              first_name
              last_name
            }
          }
          order
        }
        away {
          squad {
            _id
            opta_shirt_number
            stats
            player {
              first_name
              last_name
            }
          }
          order
        }
      }
      home_fighter {
        _id
        first_name
        last_name
        image
        image_2
        stories
        corner
        shorts_colour
        nationality {
          code
        }
      }
      away_fighter {
        _id
        first_name
        last_name
        short_name
        image
        image_2
        stories
        corner
        shorts_colour
        nationality {
          code
        }
      }
      live_data
      prediction_data
      number_of_rounds
      gold_fight
      championship_bar
      round_minutes
      title
      winner
      winnerby
      completed
    }
  }
`;

const GAMES_BY_MONTH = gql`
  query Games($date: String) {
    gamesByMonth(date: $date) {
      _id
      date
    }
  }
`;

const Main = styled.div`
  display: flex;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
`;
const GamesDiv = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
  overflow-y: auto;
  height: 95vh;
`;
const Game = styled.div`
  display: flex;
  width: 100%;
  padding: 0.5em;
  justify-content: center;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
  box-sizing: border-box;
  background-color: ${(props) =>
    props.sub ? " #181d25" : props.selected ? "#db0a41" : "#202731"};
  border-bottom: 2px solid #181d25;
  cursor: ${(props) => (props.clickable ? "pointer" : "")};
  :hover {
    ${(props) => !props.noHover && !props.selected && { color: "#d11e42" }}
  }
`;
const Team = styled.div`
  display: flex;
  margin: 0.5em;
  width: 45%;
  justify-content: ${(props) => (props.right ? "flex-end" : "")};
`;
const Verses = styled.div`
  width: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Competitions = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #202731;
  margin-left: 1px;
  width: ${(props) => (props.iPad ? "500px" : "300px")};
  padding: 1em;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

export default function CommsGames({ onSelectGame, iPad }) {
  const { mode } = useContext(UIContext);
  const { setGamesByDate } = useContext(DataContext);
  const history = useHistory();
  const location = useLocation();
  const [fixtures, setFixtures] = useState([]);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedMonth, setSelectedMonth] = useState(moment());
  const [monthFixtures, setMonthFixtures] = useState();

  // TODO - ADDD LOADING AND ERROR STATES
  const [getFixtures, { data }] = useLazyQuery(GAMES_BY_DATE);
  const [getMonthFixtures, { data: month_data }] = useLazyQuery(
    GAMES_BY_MONTH,
    {
      fetchPolicy: "network-only",
    }
  );

  useEffect(() => {
    if (date) {
      getFixtures({ variables: { date: date + "Z" } });
    }
  }, [date, getFixtures]);

  useEffect(() => {
    if (data) {
      const games = [...(data.gamesByDate || [])];
      setFixtures(games);
      setGamesByDate(games);
    }
  }, [data]);

  useEffect(() => {
    if (selectedMonth) {
      getMonthData();
    }
  }, [selectedMonth, getMonthFixtures]);

  useEffect(() => {
    if (month_data) {
      setMonthFixtures([...(month_data?.gamesByMonth || [])]);
    }
  }, [month_data]);

  function getMonthData() {
    getMonthFixtures({
      variables: { date: selectedMonth.format("YYYY-MM-DD") + "Z" },
    });
  }

  return (
    <div className="w-dvw h-dvh flex flex-col items-start justify-center m-5 bg-[#060e20]">
        <CalendarUI
        className="h-[280px] w-[280px]"
          onChangeDate={(date) => {
            setDate(moment(date).format("YYYY-MM-DD"));
          }}
          date={moment()}
          onActiveStartDateChange={({ activeStartDate, value }) => {
            setSelectedMonth(moment(activeStartDate));
          }}
          highlights={monthFixtures?.map((m) => m.date)}
        />
        <div className="flex-col flex h-[95dvh] w-[100%] overflow-y-auto mt-5">
          {fixtures
            ?.sort((a, b) => {
              if (a.competition > b.competition) {
                return 1;
              } else if (a.competition < b.competition) {
                return -1;
              }
              if (a.order > b.order) {
                return 1;
              } else if (a.order < b.order) {
                return -1;
              }
              let a_date = moment(a.date + " " + a.time);
              let b_date = moment(b.date + " " + b.time);
              // Else go to the 2nd item
              if (a_date < b_date) {
                return -1;
              } else if (a_date > b_date) {
                return 1;
              } else {
                // nothing to split them
                return 0;
              }
            })
            ?.map((fixture, index) => {
              return (
                <div className="flex flex-col w-[100%] justify-center items-center font-bold">
                  {(index === 0 ||
                    fixtures[index - 1].competition._id !==
                      fixture.competition._id) && (
                    <div className="text-primary">{fixture.competition?.name}</div>
                  )}
                  <div className="flex justify-center items-center w-[100%] p-2 cursor-pointer hover:bg-[#2c3340] rounded my-1
                  bg-[#0f1930] hover:border-[#76ffb0] hover:border-2"
                    onClick={() => {
                      onSelectGame(fixture);
                      let path = location.pathname;

                      history.push({
                        pathname:
                          location.pathname.replace("/", "") +
                          "/" +
                          fixture._id,
                      });
                    }}
                  >
                    <div className="flex justify-start align-start w-[40%] m-2">
                      {fixture.home_fighter?.first_name}{" "}
                      {fixture.home_fighter?.last_name}
                    </div>
                    <div className="flex flex-col align-center justify-center w-[20%] text-center font-normal">
                      <div>
                        Fight {index + 1}
                      </div>
                    </div>
                    <div className="flex justify-end align-end w-[40%] mx-2">
                      {fixture.away_fighter?.first_name}{" "}
                      {fixture.away_fighter?.last_name}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
    </div>
  );
}
